import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '../../component/login/login.component';
import { DashComponent } from '../../component/dash/dash.component';
import { HomeComponent } from '../../component/module/home/home.component';
import { AuthGuard } from '../../class/auth-guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard]},
  { path: 'dashboard', component: DashComponent , canActivate: [AuthGuard] },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [ 
    CommonModule, 
    RouterModule.forRoot(routes) 
  ],
	exports: [RouterModule],
	providers:[AuthGuard],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/module/app-routing/app-routing.module.ts